import { useUiStore } from '../store';

/**
 * 화면 상단 고정 배너 — Phase 4 결정 #7. toast 라이브러리는 Phase 5에서 검토.
 * usageAlert가 store에 박혀있을 때만 노출. dismiss 누르면 사라진다.
 */
export default function UsageAlertBanner() {
  const alert = useUiStore((s) => s.usageAlert);
  const dismiss = useUiStore((s) => s.dismissUsageAlert);

  if (!alert) return null;

  return (
    <div
      role="alert"
      className="border-b border-amber-300 bg-amber-50 px-4 py-2 text-amber-900"
    >
      <div className="mx-auto flex max-w-5xl items-center gap-3 text-sm">
        <span aria-hidden>⚠️</span>
        <span>
          <strong>LLM 일 토큰 한도 근접</strong> — {alert.date}{' '}
          {alert.tokensToday.toLocaleString('ko-KR')} / 예산{' '}
          {alert.budgetTokens.toLocaleString('ko-KR')} (호출 {alert.callsToday}회)
        </span>
        <button
          type="button"
          onClick={dismiss}
          className="ml-auto rounded border border-amber-300 px-2 py-0.5 text-xs hover:bg-amber-100"
        >
          닫기
        </button>
      </div>
    </div>
  );
}
